/* src/app/features/player/components/player-loading-spinner/player-loading-spinner.component.scss */
.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000000;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=player-loading-spinner.component.css.map */
